export default __webpack_public_path__ + "static/media/laptop3.95cb8bac.svg";